import { render, staticRenderFns } from "./Notic3.vue?vue&type=template&id=ea04481c&scoped=true"
import script from "./Notic3.vue?vue&type=script&lang=js"
export * from "./Notic3.vue?vue&type=script&lang=js"
import style0 from "./Notic3.vue?vue&type=style&index=0&id=ea04481c&prod&scoped=true&lang=scss"
import style1 from "./Notic3.vue?vue&type=style&index=1&id=ea04481c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea04481c",
  null
  
)

export default component.exports